module.exports = __webpack_public_path__ + "static/img/3.fac440a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = lQgp
// module chunks = 1